import { Button } from '@eventbrite/marmalade';
import styles from './ContactButton.module.scss';
import { FormattedMessage } from 'react-intl';
import { useAppContext } from '../../context/AppContext';

export type ContactButtonProps = {
  organizerId: string;
  organizerName?: string;
};

export const ContactButton = ({ organizerId, organizerName }: ContactButtonProps) => {
  const { data: appContextData } = useAppContext();
  const domainUrl = appContextData.serverUrl;

  if (!organizerId) {
    return null;
  }

  const handleClick = () => {
    window.location.href = `${domainUrl}/o/${organizerId}?contact_organizer=true`;
  };

  return (
    <Button variant="secondary" className={styles.contactButton} onClick={handleClick} data-testid="contact-button">
      {organizerName ? <FormattedMessage id="Contact" /> : <FormattedMessage id="Contact organizer" />}
    </Button>
  );
};
